import { withFocusable } from './FocusableHoc/FocusableHOC';
import { CoreButtonNext as Button } from './CoreButtonNext';
export const CoreButtonNext = withFocusable(Button);
//# sourceMappingURL=index.js.map